// import styled from "styled-components"

const Contact = (props) =>{
    document.title="Contact Us"

    return <h1>PROM</h1>

};

export default Contact;